<template>
    <section class="plans container" id="pricing" data-anchor="pricing">

        <div class="plans-container">
            <Plan v-for="(plan, index) in plans"
                  :key="plan.id"
                  :data="plan"
                  :index="index"
                  @subscribe="onSubscribe"
            >
            </Plan>
        </div>

    </section>
</template>

<script>
    import Plan from "./Plan"

    export default {
        name: "Plans",
        components: {
            Plan
        },
        data() {
            return {
                plans: [
                    {
                        title: "Basic",
                        icon: 'people.svg',
                        price: 0,
                        features: [
                            '1 workplace',
                            '0.20% trade fee',
                            '0 managed accounts included'
                        ]
                    },
                    {
                        title: "Starter",
                        icon: 'rocket.svg',
                        price: 29,
                        features: [
                            '1 workplace',
                            '0.15% trade fee',
                            '0 managed accounts included'
                        ]
                    },
                    {
                        title: "Pro",
                        icon: 'star.svg',
                        price: 149,
                        features: [
                            '1 workplace',
                            '0.125% trade fee',
                            '10 managed accounts included',
                            '+$15 additional managed account'
                        ]
                    },
                    {
                        title: "Business",
                        icon: 'peoples.svg',
                        price: 299,
                        features: [
                            '5 workplace',
                            '0.10% trade fee',
                            '50 managed accounts included',
                            '+$10 additional managed account'
                        ]
                    },
                    {
                        title: "Institutional",
                        icon: 'institute.svg',
                        price: 999,
                        features: [
                            '10 workplace',
                            '0.075% trade fee',
                            '100 managed accounts included',
                            '+5$ additional managed account'
                        ]
                    },
                ]
            }
        },
        methods: {
            onSubscribe(index) {

                this.$emit('subscribe', index)

            }
        }
    }
</script>